module.exports = __webpack_public_path__ + "./fonts/montserrat-latin-700italic.283438e9577fe6a684466bb100e105ec.woff2";